import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Reporter, ChoiceYesNoField, TextboxField, CustomTextField, DateTimeField } from '../molecules';

import styles from './Content.module.scss';
import { ResponsiblePicker } from '../molecules/ResponsiblePicker';
import { useDispatch, useSelector } from 'react-redux';
import { selectFormData } from '../../redux/form-data-slice';
import {
	selectReport,
	setAffectedData,
	setAffectedPersons,
	setDescription,
	setFurtherPersons,
	setLostDevice,
	setOccurence,
	setRecognition,
	setReporter,
	setResponsible,
} from '../../redux/report-slice';

export const Content = () => {
	const { t } = useTranslation();
	const dispatch = useDispatch();

	const formData = useSelector(selectFormData);
	const report = useSelector(selectReport);

	useEffect(() => {
		dispatch(setRecognition(new Date().getTime()));
	}, [dispatch]);

	return (
		<div className={styles.rowContainer}>
			<ResponsiblePicker
				responsible={formData.responsibleAhks}
				onChange={(v) => {
					dispatch(setResponsible(v));
				}}
				error={formData.errors.find((e) => e.key === 'responsible')?.message}
			/>
			<Reporter
				userinfo={report.reporter}
				onChange={(v) => {
					dispatch(setReporter(v));
				}}
				error={formData.errors.find((e) => e.key === 'reporter')?.message}
			/>
			<div>
				<ChoiceYesNoField
					label={t('further persons.label')}
					description={t('further persons.description')}
					onChange={(v) => {
						dispatch(setFurtherPersons(v));
					}}
				/>
				<ChoiceYesNoField
					label={t('lost device.label')}
					description={t('lost device.description')}
					onChange={(v) => {
						dispatch(setLostDevice(v));
					}}
				/>
				<TextboxField
					label={t('db description.label')}
					description={t('db description.description')}
					error={formData.errors.find((e) => e.key === 'description')?.message}
					onChange={(v) => {
						dispatch(setDescription(v));
					}}
				/>
			</div>
			<div className={styles.twoColumn}>
				<CustomTextField
					label={t('affected persons.label')}
					description={t('affected persons.description')}
					required={true}
					error={formData.errors.find((e) => e.key === 'affectedPersons')?.message}
					onChange={(v) => {
						dispatch(setAffectedPersons(v));
					}}
				/>
				<CustomTextField
					label={t('affected datasets.label')}
					description={t('affected datasets.description')}
					required={true}
					error={formData.errors.find((e) => e.key === 'affectedData')?.message}
					onChange={(v) => {
						dispatch(setAffectedData(v));
					}}
				/>
			</div>
			<div className={styles.twoColumn}>
				<DateTimeField
					label={t('db occurrence.label')}
					description={t('db occurrence.description')}
					required={false}
					onChange={(v) => {
						dispatch(setOccurence(v.getTime()));
					}}
				/>
				<DateTimeField
					label={t('db recognition.label')}
					description={t('db recognition.description')}
					required={true}
					defaultValue={new Date()}
					error={formData.errors.find((e) => e.key === 'recognition')?.message}
					onChange={(v) => {
						dispatch(setRecognition(v.getTime()));
					}}
				/>
			</div>
		</div>
	);
};
